import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => {
  return createStyles({
    alert: {
      backgroundColor: '#EAF4FC',
      marginBottom: theme.spacing(3),
      paddingRight: theme.spacing(4),
      boxSizing: 'border-box',
      borderRadius: '5px',
    },

    heading: {
      filter: 'brightness(50%)',
      fontSize: '1rem',
      fontWeight: 500,
      padding: `${theme.spacing(0.5)}px 0`,
    },
  });
});
